import React, { FC, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { TGridCSSVariables } from '../../../../constants/table.constants';
import useStickyWrapper from '../../../../hooks/useStickyWrapper';
import { TFixedColHeadingProps } from '../../types/index.types';

const FixedColHeading: FC<TFixedColHeadingProps> = (props) => {
    const {
        fixedColumnHeading,
        hideRowsHeader,
        children,
        gridColumns,
        gridFixedColHeadsMoveBy,
        gridFirstColumnWidth,
        gridColumnWidth,
        gridOutsideSpaceHalved,
        gridLeftCellsMoveBy,
    } = props;
    const FixedColHeadingRef = useRef<HTMLDivElement>(null);
    const [variableInserted, setVariablesInserted] = useState<boolean>(fixedColumnHeading);
    const stickyWrapperEle = useStickyWrapper();

    useEffect(() => {
        if (!fixedColumnHeading) {
            setVariablesInserted(() => false);
            return;
        }
        const fixedColHeadingEl = FixedColHeadingRef.current as HTMLElement | null;
        if (!fixedColHeadingEl) return;
        fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridColumns, gridColumns);
        fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridFixedColHeadsMoveBy, gridFixedColHeadsMoveBy);
        fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridFirstColumnWidth, gridFirstColumnWidth);
        fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridColumnWidth, gridColumnWidth);
        fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridOutsideSpaceHalved, gridOutsideSpaceHalved);
        fixedColHeadingEl.style.setProperty(TGridCSSVariables.gridLeftCellsMoveBy, gridLeftCellsMoveBy);
        setVariablesInserted(() => true);
    }, [
        setVariablesInserted,
        fixedColumnHeading,
        FixedColHeadingRef,
        gridColumns,
        gridFixedColHeadsMoveBy,
        gridFirstColumnWidth,
        gridColumnWidth,
        gridOutsideSpaceHalved,
        gridLeftCellsMoveBy,
    ]);

    if (!stickyWrapperEle || !fixedColumnHeading) return null;

    return createPortal(
        <div className={`model-detail-specification-table__fixed-col-heading-wrapper ${(!variableInserted || !fixedColumnHeading) && 'model-detail-specification-table__fixed-col-heading-wrapper--hide'}`} ref={FixedColHeadingRef}>
            <div className="model-detail-specification-table__fixed-col-heading--box-shadow-el" />
            <div className="model-detail-specification-table__fixed-col-heading--left-cover" />
            <div className="model-detail-specification-table__fixed-col-heading">
                <div />
                {!hideRowsHeader && (
                    <div className="model-detail-specification-table__empty model-detail-specification-table__left-most-cell model-detail-specification-table__left-most-cell--no-transition"></div>
                )}
                {children}
                <div />
            </div>
            <div className="model-detail-specification-table__fixed-col-heading--right-cover" />
        </div>,
        stickyWrapperEle
    );
};

export default FixedColHeading;
